/**
 * @desc Snowmaking pipeleak state actions, mutations and default state values
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "pipeleaks",
    layerTitle: "Pipe Leaks",
    geojson: [],
    visibility: {
      mapView: false,
      listView: false,
      singleView: false,
      singleId: 0
    },
    loading: false,
    hasListView: true,
    legend: [
      {
        id: 0,
        name: "Not fixed",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/not_complete.png"
      },
      {
        id: 1,
        name: "2021 to present",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/orange_2021_to_present.png"
      },
      {
        id: 2,
        name: "2017 to 2020",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/yellow_2020_2019_2018_2017.png"
      },
      {
        id: 3,
        name: "2012 to 2016",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/dk_blue_2016_2015_2014_2013_2012.png"
      },
      {
        id: 4,
        name: "2007 to 2011",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/dark_blue_2011_2010_2009_2008_2007.png"
      },
      {
        id: 5,
        name: "2002 to 2006",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/med_blue_2006_2005_2004_2003_2002.png"
      },
      {
        id: 6,
        name: "2001 & before",
        iconurl:
          "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/pipeleaks/blue_pre_2002.png"
      }
    ]
  }
};
